import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-type-range',
  templateUrl: './type-range.component.html',
  styleUrls: ['./type-range.component.scss']
})

export class TypeRangeComponent implements OnInit {

  @Input()
  set values(values: number[]) {
    this.arrayValues = values;
  }

  get values(): number[] {
    return this.arrayValues;
  }

  @Output()
  valuesChange = new EventEmitter<number[]>();

  @Input()
  max: number;

  @Input()
  label: string;

  @Input()
  columns = 4;

  arrayValues = [];

  error = false;

  private secondBackspace = false;

  constructor() { }

  ngOnInit(): void {
  }

  onKeyUp(event: any): void {

    if (this.deleteInput(event)) {
      this.error = false;
      this.arrayValues.pop();
      this.updateArrays();
    }
  }

  change(inputIndex: number, value: string): void {
    const lastValue = Number(this.values[inputIndex]);
    const currentValue = Number(value);

    if (currentValue > lastValue) {
      this.error = false;
      this.arrayValues.push(currentValue);
      this.updateArrays();
    } else {
      this.error = true;
    }
  }

  private updateArrays(): void {
    this.valuesChange.next(this.values);
  }

  private deleteInput(event: any) {
    if (event.keyCode !== KEY_BACKSPACE) {
      this.secondBackspace = false;
      return false;
    }
    if (this.arrayValues.length < 2) {
      return false;
    }
    if (event.target.value === '') {
      if (this.secondBackspace) {
        return true;
      }
      this.secondBackspace = true;
    }
    return false;
  }

}

const KEY_BACKSPACE = 8;
